import { ENTITY_DOCUMENT_TYPE_SHORT_CODES, ENTITY_DOCUMENT_TYPE_VALUES, MAX_ENTITY_DOCUMENTS } from '../constants/accountType.constants';
import { ENTITY_DOC_ALLOWED_FORMATS, validateEntityDocFileSize } from './fileValidation';

export const getEntityDocumentKey = (file, docType) => `${docType}::${file?.name}::${file?.size}::${file?.lastModified}`;

// Browsers don't expose the order files were clicked in a native picker (Windows usually puts the
// last-clicked file first) or dragged in, so the selection is ordered by file name. That keeps the
// files that get the free slots the same every time the same files are picked.
const compareByFileName = (a, b) => a.item.name.localeCompare(b.item.name, undefined, { numeric: true, sensitivity: 'base' });

// Decides which picked files become added documents. Locked PDFs, invalid files and duplicates are
// dropped first so they never use up a slot; the remaining files fill the free slots in name order
// and anything past the limit is returned in skippedForLimit so the UI can name it.
export const selectEntityDocuments = ({ fileList, passwordChecks, addedDocuments, docType }) => {
  const docTypeValue = ENTITY_DOCUMENT_TYPE_VALUES[docType] || docType;
  const docTypeShortCode = ENTITY_DOCUMENT_TYPE_SHORT_CODES[docType] || docTypeValue;
  const takenKeys = new Set(addedDocuments.map((documentItem) => documentItem.key));
  let remainingSlots = MAX_ENTITY_DOCUMENTS - addedDocuments.length;

  const result = {
    documentsToAdd: [],
    skippedForLimit: [],
    hasPasswordProtected: false,
    hasInvalidFormat: false,
    hasInvalidSize: false,
    hasDuplicate: false,
  };

  const orderedFiles = fileList.map((item, index) => ({ item, isLocked: passwordChecks[index] })).sort(compareByFileName);

  orderedFiles.forEach(({ item, isLocked }) => {
    const file = item.originFileObj;
    const key = getEntityDocumentKey(file, docType);

    if (isLocked) {
      result.hasPasswordProtected = true;
    } else if (!ENTITY_DOC_ALLOWED_FORMATS.includes(file?.type)) {
      result.hasInvalidFormat = true;
    } else if (!validateEntityDocFileSize(file?.size)) {
      result.hasInvalidSize = true;
    } else if (takenKeys.has(key)) {
      result.hasDuplicate = true;
    } else if (remainingSlots <= 0) {
      result.skippedForLimit.push(item.name);
    } else {
      takenKeys.add(key);
      remainingSlots -= 1;
      result.documentsToAdd.push({
        uid: item.uid,
        key,
        docType,
        docTypeValue,
        docTypeShortCode,
        fileName: item.name,
        originFileObj: file,
      });
    }
  });

  return result;
};

export const getEntityDocLimitMessage = (skippedFileNames) => {
  const count = skippedFileNames.length;
  const fileLabel = count === 1 ? 'file was' : 'files were';
  return `${count} ${fileLabel} not added because the limit of ${MAX_ENTITY_DOCUMENTS} documents was reached: ${skippedFileNames.join(', ')}`;
};
